import { render } from "./TextViewer.vue?vue&type=template&id=52ba7ab4"
import script from "./TextViewer.vue?vue&type=script&lang=js"
export * from "./TextViewer.vue?vue&type=script&lang=js"

import "./TextViewer.vue?vue&type=style&index=0&id=52ba7ab4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__